// 配置应用的AppKey
// 壹心理M站 key：be2579193b754fd2900f660a0093fa62
// 壹心理APP key：f6f19cec54894af8990714a597fc09f4
// 口袋心理APP：c6ef6a45ade340999081be514623f29e
// 壹心理学院（kc）：38193a7a6e34415daeef0cb2b0002e54
// 活动汇总项目（kc）：e989fdd0fb8b4af384ec7c87c2d9cfb4

export default {
  msite: 'be2579193b754fd2900f660a0093fa62',
  yxlApp: 'f6f19cec54894af8990714a597fc09f4',
  cpApp: 'c6ef6a45ade340999081be514623f29e',
  kc: '38193a7a6e34415daeef0cb2b0002e54',
  yixinliPC: '18f5038ab49c4ae4918641ae36d67496',
  promotion: 'e989fdd0fb8b4af384ec7c87c2d9cfb4'
}



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/stat/zhugeIO_keys.js